module.exports = __webpack_public_path__ + "images/category_lp/watch/assessment_achievements/1@2x_b36afba7dd66c200e637f297dea7be44.png";